module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "side-menu levela",
    class: {
      fixed: _vm.getSidemenuStatus
    }
  }, [_c('li', {
    staticClass: "item index"
  }, [_c('router-link', {
    staticClass: "title",
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "icon icon-menu-logo"
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v("首页")])])], 1), _vm._v(" "), _vm._l((_vm.menu), function(levelA, index) {
    return _c('li', {
      staticClass: "item"
    }, [_c('a', {
      staticClass: "title",
      class: {
        'child': levelA.child, active: _vm.clickIndex === index
      },
      attrs: {
        "id": 'menu-' + levelA.id
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.enter(levelA, index)
        }
      }
    }, [_c('span', {
      staticClass: "icon",
      class: levelA.icon
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(levelA.name))])]), _vm._v(" "), (levelA.child) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.clickIndex === index),
        expression: "clickIndex === index"
      }],
      staticClass: "scroll-box",
      style: (_vm.maxHeight),
      attrs: {
        "id": 'scroll' + index
      }
    }, [_c('ul', {
      staticClass: "levelb"
    }, _vm._l((levelA.child), function(levelB, indexB) {
      return _c('li', {
        staticClass: "item",
        on: {
          "mouseover": function($event) {
            _vm.clearTime(indexB)
          },
          "mouseout": _vm.moveOut
        }
      }, [_c('a', {
        staticClass: "title",
        class: {
          'child': levelB.child, active: _vm.hoverIndex === indexB, 'router-active': levelB.url === _vm.currentIndex || _vm.selectLevelB(levelB.child)
        },
        attrs: {
          "id": 'menu-' + levelB.id
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.enter(levelB, index)
          }
        }
      }, [_c('span', {
        staticClass: "icon",
        class: levelB.icon
      }), _vm._v(" "), _c('span', {
        staticClass: "name"
      }, [_vm._v(_vm._s(levelB.name))]), _vm._v(" "), _c('div', {
        staticClass: "bind-event",
        on: {
          "mouseover": function($event) {
            if ($event.target !== $event.currentTarget) { return null; }
            _vm.moveOn($event, levelB.child)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "transition",
        style: (_vm.fixedStyle)
      }, [(levelA.child) ? _c('ul', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.hoverIndex === indexB),
          expression: "hoverIndex === indexB"
        }],
        staticClass: "levelc"
      }, _vm._l((levelB.child), function(levelC) {
        return _c('li', {
          staticClass: "item"
        }, [_c('a', {
          staticClass: "title",
          class: {
            'router-active': levelC.url === _vm.currentIndex
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.enter(levelC, index)
            }
          }
        }, [_c('span', {
          staticClass: "name"
        }, [_vm._v(_vm._s(levelC.name))])])])
      })) : _vm._e()])])
    }))]) : _vm._e()])
  }), _vm._v(" "), _c('li', {
    staticClass: "switch",
    class: {
      fixed: _vm.getSidemenuStatus
    },
    on: {
      "click": _vm.handleSwitch
    }
  }, [_vm._m(0)])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;",
      "title": "固定左侧菜单栏"
    }
  }, [_c('i', {
    staticClass: "web-icon-stick"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d6aa82c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/side-menu.vue
// module id = 1284
// module chunks = 82